const pages = [];

function loadPages () {
  if (pages.length === 0) {
    const toc = require('../manual/toc.json');
    toc.pages.forEach(p => {
      p.data = require('../manual/' + p.page).default;
      pages.push(p);
    });
  }
  return pages;
}

export function getManualPages () {
  return loadPages();
}

export function getManualPageByPath (path) {
  const pages = loadPages();
  return pages.find((p) => p.path === path);
}

export function getManualPageByFilename (fileName) {
  const pages = loadPages();
  return pages.find((p) => p.page === fileName);
}
